<template>
  <div class="auto-correction-editor mt-10">
    <label
      class="auto-correction-editor__label"
      for="input-answer-content"
    >回答（必須）*</label>
    <BaseOverlayEditor
      ref="overlayEditor"
      v-model="editorText"
      :suggestions="allSuggestionsForEditor"
      :selected-suggestion-id="selectedSuggestionId"
      :height="600"
      :auto-grow="false"
      textarea-node-id="input-answer-content"
      @select-suggestion="onSelectSuggestionId"
    />

    <div>
      <span data-test="content-counter">{{ answerContentLength }}文字</span>
      <span
        v-if="isEnoughContent"
        data-test="content-enough-icon"
      >
        <v-icon style="font-size: 1em">
          mdi-check
        </v-icon>
      </span>
      <span
        v-else
        data-test="content-rest-counter"
      >
        （推奨文字数まで {{ 700 - answerContentLength }} 文字）
      </span>
    </div>
  </div>
</template>

<script>
import BaseOverlayEditor from "@/vue/components/shared/overlay_editor/BaseOverlayEditor.vue";
import { mapGetters, mapActions } from "vuex";
import { SIDEBAR_TAB_IDS } from "@/vue/features/anytime-consultation-sidebar/model/sidebarTabIds";

export default {
  name: "AutoCorrectionEditor",
  components: {
    BaseOverlayEditor
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
  },
  emits: ["update:modelValue"],
  computed: {
    ...mapGetters({
      allSuggestionsForEditor: "allSuggestionsForEditor",
      selectedSuggestionId: "selectedSuggestionId"
    }),
    /**
     * v-model 対応の計算プロパティ
     * set で親に `update:modelValue` イベントを発火する
     */
    editorText: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    answerContentLength() {
      if (this.modelValue === null) return 0;
      return this.modelValue.length;
    },
    isEnoughContent() {
      return this.answerContentLength >= 700;
    }
  },
  methods: {
    ...mapActions([
      "selectSuggestionId",
      "selectSidebarTabId"
    ]),
    onSelectSuggestionId(suggestionId) {
      // BaseOverlayEditor から @select-suggestion で渡される
      this.selectSuggestionId(suggestionId);

      // 添削タブを開く
      this.selectSidebarTabId(SIDEBAR_TAB_IDS.AI_CORRECTION);
    },
  }
};
</script>

<style lang="scss" scoped>
.auto-correction-editor {
  position: relative;
  margin-top: 12px;

  &__label {
    z-index: 1;
    top: -18px;
    left: 10px;
    color: #999;
    font-size: 12px;
    position: absolute;
  }
}
</style>